import React, { useContext, useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { FavoriteBorder, Favorite } from '@mui/icons-material';
import BottomModal from './BottomModal';
import './style/CardProduct.css';
import { CartContext } from './CartContext'; // Импортируем контекст корзины
import { FavoriteContext } from './FavoriteContext'; // Импортируем контекст избранного

const CardProduct = ({ product }) => {
  const { addToCart } = useContext(CartContext); // Используем контекст корзины
  const { addToFavorites, removeFromFavorites, favorites } = useContext(FavoriteContext); // Используем контекст избранного
  const [isFavorite, setIsFavorite] = useState(false);
  const [showAddedMessage, setShowAddedMessage] = useState(false);
  const [showFavoriteMessage, setShowFavoriteMessage] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => {
    setIsFavorite(favorites.some(fav => fav.id === product.id));
  }, [favorites, product.id]);

  const toggleFavorite = (product) => {
    if (isFavorite) {
      removeFromFavorites(product.id);
    } else {
      addToFavorites(product);
      setShowFavoriteMessage(true);
      setTimeout(() => {
        setShowFavoriteMessage(false);
      }, 2000);
    }
    setIsFavorite(!isFavorite);
  };

  const handleAddToCart = (product) => {
    addToCart(product);
    setShowAddedMessage(true);
    setTimeout(() => {
      setShowAddedMessage(false);
    }, 2000);
  };

  const openModal = (product) => {
    setSelectedProduct(product);
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
    setSelectedProduct(null);
  };

  return (
    <div className="card-product-container">
      {showAddedMessage && (
        <div className="global-added-message">Товар добавлен в корзину</div>
      )}
      {showFavoriteMessage && (
        <div className="global-favorite-message">Товар добавлен в избранное</div>
      )}
      <div className="card-product-content">
        <div className="card-product-basic-content" key={product.id}>
          <div 
            className="card-product-img-container" 
            style={{ 
              backgroundImage: `url(${process.env.REACT_APP_IMAGES_URL}/${product.product_photo})`,
              backgroundSize: 'contain',  
              backgroundPosition: 'center', 
              backgroundRepeat: 'no-repeat'
            }}
          >
            <div onClick={() => openModal(product)} style={{ cursor: 'pointer' }}>
              <div className="img-button-block"></div>
            </div>
            <div className="card-product-favorite-icons-container">
              <IconButton onClick={() => toggleFavorite(product)} className="card-product-favorite-icons-button">
                {isFavorite ? <Favorite color="error" /> : <FavoriteBorder />}
              </IconButton>
            </div>
          </div>
          <div className="card-product-name-container">
            <div className="card-product-name-block">
              <span className="card-product-tovar-name" title={product.name}>{product.name}</span>
            </div>
          </div>
          <div className="card-product-button-container">
            <div className="card-product-basic-button">
              <button onClick={() => handleAddToCart(product)} className="card-product-button-knopka">
                <ShoppingCartIcon />
                <span className="price">{product.price} T</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div>
        <BottomModal isOpen={isOpen} onClose={closeModal} product={selectedProduct} />
      </div>
    </div>
  );
};

export default CardProduct;
